import PromptsContainer from './PromptsContainer'

export default  PromptsContainer